import axios from '@/libs/api.request'

export const uploadToFileSystem = ({ file, filename, targetDirPath, bucket }) => {
  return axios.request({
    url: '/timesheet/mentee/schedule',
    data: {
      file: file,
      filename: filename,
      targetDirPath: targetDirPath,
      bucket: bucket
    },
    method: 'POST'
  })
}

export const editorImgUpload = ({ file }) => {
  let data = new FormData()
  data.append('file', file)
  data.append('filename', new Date().getTime() + '')
  data.append('targetDirPath', '/common')
  data.append('bucket', 'ZLR_VALEON_OM')
  return axios.request({
    url: '/file/system/upload',
    data: data,
    method: 'POST'
  })
}
